app.service('subscriptionServiceInvoiceForm', function (loading, modal, account, validate, addressIntegrityValidator) {

	function init(props) {
		const {loadSubscriptionServiceDetails} = props;
		setEvents(loadSubscriptionServiceDetails);
	}

	function setEvents(loadSubscriptionServiceDetails) {

		$("body")
			.on("click", ".js-change-invoice-data", function() {
				handleChangeInvoiceDataClick.call(this, loadSubscriptionServiceDetails);
			})
			.on("change", ".invoice-type-switch input", handleInvoiceTypeSwitchClick)
			.on("click", ".js-cancel-data-change", function handleCancelDataChangeClick() {
				$(this).closest(".invoice-details-form").attr("hidden", "hidden");
				$(this).closest(".info-section").find('.invoice-details').removeAttr("hidden");
				$.scrollTo($(this).closest(".subscription-item"));
			});
	}


	function handleValidInvoiceDataSubmit(formData, loadSubscriptionServiceDetails) {

		loading.start();

		const updateInvoiceData = getUpdateInvoiceData(formData);

		const loadSubscriptionServiceDetailsWithParams = () => {
			const {recurringPaymentId, pluList, initialOrderId} = getSubscriptionServiceDetailsUrlParams(formData);
			return loadSubscriptionServiceDetails(recurringPaymentId, pluList, initialOrderId);
		};

		addressIntegrityValidator.validateAddressIntegrity(updateInvoiceData)
			.then(response => {
				if (response.message !== "") {
					modal.generate({
						id: "adress-validate-modal",
						content: response.message,
						buttons: [
							{
								text: "Tak",
								cssClass: "btn-second",
								click: modal.close
							}, {
								text: "Nie, idę dalej",
								cssClass: "btn-fourth",
								click: function handleIgnoreAddressIntegrityIssuesClick() {
									makeUpdateInvoiceDataRequest(updateInvoiceData, loadSubscriptionServiceDetailsWithParams);
								}
							}
						]
					});

					return;
				}

				makeUpdateInvoiceDataRequest(updateInvoiceData, loadSubscriptionServiceDetailsWithParams);
			})
			.fail(() => {
				modal.alert(getErrorMsg());
			})
			.always(() => {
				loading.stop();
			});
	}

	function makeUpdateInvoiceDataRequest(updateInvoiceData, loadSubscriptionServiceDetailsWithParams) {

		loading.start();

		$.ajax({
			url: "/customer-subscription-invoice-data-update.ltr",
			type: "POST",
			dataType: "json",
			contentType: "application/json",
			data: JSON.stringify(updateInvoiceData)
		})
			.then(response => {
				if (response.status === "FAIL") {
					modal.alert(response.messages.join("<br />"));
					return;
				}

				return loadSubscriptionServiceDetailsWithParams()
					.then(html => {
						let $subscriptionItem = $(`.subscription-item[data-id=${updateInvoiceData.recurringPaymentId}]`);
						$subscriptionItem.html(html);
						modal.close();
						$.scrollTo($subscriptionItem);
					});
			})
			.fail(() => {
				modal.alert(getErrorMsg());
			})
			.always(() => {
				loading.stop();
			});
	}

	function getErrorMsg() {
		return '<div class="error-message">Wystąpił błąd komunikacji. Odśwież stronę, aby próbować ponownie.</div>';
	}

	function getSubscriptionServiceDetailsUrlParams(formData) {

		const validFields = ['recurringPaymentId', 'pluList', 'initialOrderId'];

		return extractFormFields(formData, validFields);
	}

	function getUpdateInvoiceData(formData) {

		const validFields = ['recurringPaymentId', 'firstName', 'lastName', 'nip', 'companyName', 'companyNameCont', 'zipCode', 'street', 'city', 'houseNumber', 'flatNumber'];

		return extractFormFields(formData, validFields);
	}

	function extractFormFields(formData, validFields) {

		return formData
			.filter(element => validFields.indexOf(element.name) !== -1)
			.reduce((acc, element) => {
				let obj = acc || {};
				obj[element.name] = element.value;
				return obj;
			}, {});
	}

	function handleChangeInvoiceDataClick(loadSubscriptionServiceDetails) {
		let $form = $(this).closest('.info-section').find('.invoice-details-form');

		$form.removeAttr("hidden");
		$(this).closest('.invoice-details').attr("hidden", "hidden")

		$('input[name=zipCode]').mask2('99-999').keyfilter(/[\d\-]/);

		$('input[name=city]').each(function() {
			if (!$(this).parent().hasClass('city-autocomplete-wrapper')) {
				$(this).wrap('<div class="city-autocomplete-wrapper"></div>')
			}
		});
		$.cityAutocomplete('input[name=zipCode]', 'input[name=city]');

		validate.task('subscriptionServiceInvoiceDataForm', {
			$form: $form,
			onValidInvoiceData() {

				if (!account.isFrontUserLogged()) {
					modal.alert("Twoja sesja wygasła. Zaloguj się ponownie, aby kontynuować.", function goToLoginPage() {
						document.location.reload();
					});
					return;
				}

				const formData = $form.serializeArray();

				handleValidInvoiceDataSubmit(formData, loadSubscriptionServiceDetails);
			}
		});
	}

	function handleInvoiceTypeSwitchClick() {
		$(this).closest('form')
			.find('[name=firstName], [name=lastName], [name=nip], [name=companyName], [name=companyNameCont]')
			.each(function () {
				if ($(this).is(":disabled")) {
					$(this).removeAttr("disabled");
				} else {
					$(this).attr("disabled", "disabled");
				}
			})
			.closest('.column')
			.toggleClass('is-disabled');
	}

	return {
		init
	};
});